import 'rxjs/add/operator/debounceTime';
import {Component, ViewChild} from '@angular/core';
import {Content, NavController, NavParams, ViewController} from 'ionic-angular';
import {Searched} from "../../../components/searched/searched";

import {CONFIG} from '../../../app/config';
import {TAction, TProfileTeam, TImageModel, THotspotFlag, THotspotList} from "../../../app/enum";
import {TGoogleAnalytic, TStatusBar, Util} from "../../../app/util";

import {MessageService} from '../../../providers/message-service';
import {LogadoService} from '../../../providers/logado-service';
import {BrandedMenuPage} from "../branded-menu/branded-menu";
import {HotspotMenuPage} from "../hotspot-menu/hotspot-menu";
import {WebstorService} from "../../../providers/webstor-service";
import {ProfileService} from "../../../providers/profile-service";
import {SupportMenuPage} from '../support-menu/support-menu';

@Component({
    selector: 'page-negocio-menu',
    templateUrl: 'negocio-menu.html',
    providers: [WebstorService, ProfileService]
})
export class NegocioMenuPage {

    TImageModel: any = TImageModel;
    THotspotList: any = THotspotList;

    config: any;
    logado: any;
    rootile: any;

    etapa: number;

    manager: boolean;
    partner: boolean;
    hotspotList: THotspotList;
    hotspotFlag: THotspotFlag;

    brandcount: number = 5;
    hotspotLoad: boolean;

    flagstor: boolean;
    negocios: any;
    copycios: any;
    brandlis: any;
    prepares: any;

    partnerID: number;

    visibleView: TImageModel;

    scrollTop: number;
    @ViewChild(Content) content: Content;
    @ViewChild(Searched) searched: Searched;

    constructor(public navCtrl: NavController, public viewCtrl: ViewController, public navParams: NavParams,
                public util: Util, public webstorService: WebstorService,
                public messageService: MessageService,
                public logadoService: LogadoService, public profileService: ProfileService) {

        this.config = CONFIG;
        this.logado = this.logadoService.getAuth();
        this.rootile = this.navParams.get('rootile');

        this.etapa = this.navParams.get('etapa');

        this.manager = (this.rootile.Profile.ProfileTeam >= TProfileTeam.mkManager);
        this.partner = (this.rootile.Profile.ProfileTeam >= TProfileTeam.mkPartner);
        this.hotspotList = THotspotList.hlNegocio;
        this.hotspotFlag = THotspotFlag.hfHotspotNenhum;

        this.partnerID = this.util.anyParams(0, this.navParams.get('partnerID'));

        this.flagstor = this.navParams.get('flagstor');
        this.negocios = this.navParams.get('negocios');
        this.copycios = this.util.deepCopy(this.negocios);

        this.visibleView = (this.util.jsCount(this.copycios, ['Brandeds', 'BrandedID']) <= 8 ? TImageModel.imBranded : TImageModel.imLista);
        if (this.etapa == 1) this.gambiarraBrand();

        /* Google Analytics */
        this.util.googleAnalytic(TGoogleAnalytic.gaPageview, 'Negócio Menu', '/negocio-menu');

        if (!this.negocios) this.negocioLoad();
        if ( this.negocios) this.negocioFind();

        // Usuario excluido
        this.messageService.get('usuario.lixo').subscribe(data => this.usuarioLixo(data.HotspotID));

    }

    ngAfterViewInit() {

        //this.content.ionScroll.enableScrollListener();
        this.content.ionScroll.subscribe((scroll) => {
            console.log('user scrolled', scroll);
            this.scrollTop = scroll.scrollTop;
        });

    }

    ionViewDidEnter() {

        this.util.statusBarColor(TStatusBar.sbStyleLightContent);

        if (this.etapa == 1 && !this.hotspotLoad) {
            this.hotspotLoad = true;
            let bool = (this.negocios.length == 1 && this.negocios[0].Brandeds.length == 1 && this.negocios[0].Brandeds[0].BrandedSpots.length == 1);
            if (!bool) return;

            let negocio = this.negocios[0];
            let branded = this.negocios[0].Brandeds[0];
            let hotspot = this.negocios[0].Brandeds[0].BrandedSpots[0];
            this.hotspotPush(negocio, branded, hotspot.HotspotID, hotspot.HotspotFlag);
        }

        if (this.searched) this.searched.setFocus();

    }

    getTitle(): string {

        if (this.etapa == 0) return 'Brand';
        if (this.etapa == 1) return 'Hotspot';
        if (this.etapa == 2) return (this.partnerID ? 'Wallet' : 'Partner');

    }

    prepareLoad() {

        //COMECEI E NAO TERMINEI! Prepare Negocio, Cidade e Versao em unica request!
        
        // this.prepares = [];
        // this.copycios.forEach(NG => {

        //     let object = {IonlistNome: 'Skydive', IonlistInfo: 'Sport', IonlistLines:[]};
        //     let ubject = {IonlineNome: ''}
        //     this.prepares.push(object);

        // });

    }

    negocioOlho() {

        this.visibleView = (this.visibleView == TImageModel.imLista ? TImageModel.imBranded : TImageModel.imLista);

    }

    negocioFind() {

        //#NATIVE -> Quando é ProfileTeam, abre webstor no ADM e desliza para PDV rápido ele buga a tela
        //Deixei dar foco só para facilitar a gente no APPWEB
        if (this.util.nativeApp()) return;

        setTimeout(() => {
            if (this.searched) this.searched.setFocus();
        }, 500);

    }

    negocioLoad() {

        this.negocios = null;
        this.copycios = null;

        let action;
        if (this.etapa == 0) action = TAction.acList;
        if (this.etapa == 1) action = TAction.acSpot;
        if (this.etapa == 2) action = TAction.acTrad;

        let loading = this.util.loadingDots();
        loading.present();

        this.webstorService.negocio(action, 0, this.partnerID, this.rootile.Profile.ProfileID, this.hotspotList, this.hotspotFlag)
            .finally(() => loading.dismiss())
            .subscribe(
                data => {
                    this.negocios = data.Negocios;
                    this.copycios = this.util.deepCopy(this.negocios);
                    this.visibleView = (this.util.jsCount(this.copycios, ['Brandeds', 'BrandedID']) <= 8 ? TImageModel.imBranded : TImageModel.imLista);
                    this.prepareLoad();
                    if (this.searched) this.searched.searchStart();
                    //if (!this.searched) this.filterArrays(null);
                },
                erro => this.util.alertResult(erro, () => this.dismiss())
            );

    }

    supportWork() {

        //Hide Support Button Fab
        (window as any).handappMainInstance.supportShow = false;

        let logado = this.logadoService.getAuth();
        let object = {etapa: 0, profile: logado.Profile, hotspotID: 0, supports: null, selected: 0};
        this.util.navActive().push(SupportMenuPage, object, {animation: 'md-transition'});

    }
    
    zipcityMore(zipcity: any, press: boolean) {

        let count = zipcity.Hotspots.length;
        let somar = (zipcity.brandcount || this.brandcount) + this.brandcount;
        zipcity.brandcount = (press ? count : somar);
        if (press) this.util.impact();

    }

    brandedMore(negocio: any, press: boolean) {

        let count = negocio.Brandeds.length;
        let somar = (negocio.brandcount || this.brandcount) + this.brandcount;
        negocio.brandcount = (press ? count : somar);
        if (press) this.util.impact();

    }

    brandedView() {

        this.visibleView = (this.visibleView == TImageModel.imLista ? TImageModel.imBranded : TImageModel.imLista);

    }

    brandedNote(branded) {

        let brendexText = (branded.Brended ? ' •' + branded.Brended.BrandedNome : '');

        let qtde = (branded.BrandedBank ? 1 : 0) + (branded.BrandedCard ? 1 : 0) + (branded.BrandedGate ? 1 : 0) + (branded.BrandedClid ? 1 : 0);

        if (qtde > 0)            return brendexText + (branded.BrandedClid ? ' •API' : '') + (branded.BrandedGate ? ' •Gate' : '') + (branded.BrandedCard ? ' •Card' : '') + (branded.BrandedBank ? ' •Bank' : '');
        if (branded.HotspotQtde) return this.util.plural(branded.HotspotQtde, 'spot');
        if (branded.BlendedQtde) return this.util.plural(branded.BlendedQtde, 'blend');

        return brendexText;

    }

    brandedMenu(negocio, branded) {

        if (this.viewCtrl.isOverlay) {
            this.dismiss(branded);
            return;
        }

        if (this.etapa == 0) {

            let array = (branded ? [branded] : null);
            let object = {etapa: 1, rootile: this.rootile, brandeds: array, brended: null, negocios: this.negocios};

            if (!branded) {
                this.util.modalopen(BrandedMenuPage, 'alto', false, object).subscribe(data => this.filterArrays(''));
            }

            if (branded)  {
                this.navCtrl.push(BrandedMenuPage, object);
            }

        }

        if (this.etapa >= 1) {

            /** OPEN **/
            let buttons: Array<any> = [];
            branded.BrandedSpots.forEach(hotspot => {
                buttons.push({text: hotspot.Unidades[0].UnidadeNome, handler: () => this.hotspotPush(negocio, branded, hotspot.HotspotID, hotspot.HotspotFlag)});
            });
            this.util.sheetOpen(buttons, 'UNIDADE');

        }

    }

    hotspotPush(negocio, branded, hotspotID, status) {

        let copybra = this.util.deepCopy(branded);
        delete copybra.BrandedSpots;

        let copytra = this.util.deepCopy(negocio);
        delete copytra.Brandeds;

        copybra.Negocio = copytra;
        copybra.HotspotFlag = status;

        let object = {etapa: 0, rootile: this.rootile, hotspotID: hotspotID, branded: copybra};
        this.navCtrl.push(HotspotMenuPage, object, {animate: false});

    }

    usuarioLixo(hotspotID) {

        this.negocios.forEach((NG, indexNG) => {
            
            NG.Brandeds.forEach((BR, indexBR) => {
            
                BR.BrandedSpots.forEach((HS, indexHS) => {
                    if (HS.HotspotID == hotspotID) BR.BrandedSpots.splice(indexHS, 1);
                });

                if (BR.BrandedSpots.length == 0) NG.Brandeds.splice(indexBR, 1);
                
            });
            
            if (NG.Brandeds.length == 0) this.negocios.splice(indexNG, 1);

        });

        this.filterArrays('');

    }

    gambiarraBrand() {

        this.brandlis = [];
        if (!this.copycios || this.visibleView != TImageModel.imBranded) return;

        setTimeout(() => {

            let brandeds = [];
            this.copycios.forEach(NG => NG.Brandeds.forEach(BR => {
                let brand = this.util.deepCopy(BR);
                let trade = this.util.deepCopy(NG);
                trade.Brandeds = null;
                brand._negocio = trade; //#GAMB para imageScroll
                brandeds.push(brand);
            }));

            brandeds = this.util.arraySort(brandeds, 'BrandedID');
            this.brandlis = brandeds;
    
        }, 300);

    }

    filterArrays(terms) {

        let filtred = [
            {array: this.negocios,   field: ['NegocioID', 'NegocioNome'], types: ['int', 'str']},
            {array: 'Brandeds',      field: ['BrandedID', 'BrandedNome'], types: ['int', 'str']},
            {array: 'BrandedSpots',  field: ['HotspotID'], types: ['int']},
        ];

        this.copycios = this.util.filterArray(filtred, terms);
        this.visibleView = (this.util.jsCount(this.copycios, ['Brandeds', 'BrandedID']) <= 8 ? TImageModel.imBranded : TImageModel.imLista);

        this.gambiarraBrand();

    }

    filtredMenu() {

        let onSave = (root, ruut) => {

            this.hotspotList = root;
            this.hotspotFlag = ruut;
            this.negocioLoad();

        };

        /** OPEN **/
        let buttons: Array<any> = [];
        buttons.push({text: 'Negócio', value: THotspotList.hlNegocio});
        buttons.push({text: 'Cidade',  value: THotspotList.hlZipcity});
        buttons.push({text: 'Versão',  value: THotspotList.hlVersion});

        /** OPEN **/
        let buttuns: Array<any> = [];
        let arrayEnum = this.util.enumArray(THotspotFlag);
        arrayEnum.forEach(flag => buttuns.push({text: flag.slice(9, 99), value: THotspotFlag[flag]}));

        let columns = [];
        columns.push({name: 'root', options: buttons});
        columns.push({name: 'ruut', options: buttuns});
        columns[0].selectedIndex = this.hotspotList;
        columns[1].selectedIndex = this.hotspotFlag;
        this.util.pickerOpen(columns, onSave, null, null, 1, 0);


    }

    dismiss(result?) {

        if (result && this.viewCtrl.isOverlay) {
            this.viewCtrl.dismiss(result);
            this.util.statusBarColor(TStatusBar.sbStyleLightContent);
            return;
        }

        this.navCtrl.pop();
        this.util.statusBarColor(TStatusBar.sbStyleLightContent);

    }

}



// WEBPACK FOOTER //
// ./src/pages/sync/negocio-menu/negocio-menu.ts